module.exports = __webpack_public_path__ + "static/media/phone-orange.4f98180e.svg";